import React, {useState} from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { elLightGray, elGray } from '../../styles/colors';
import { useLocation, useParams } from 'react-router-dom';
import {
  LinkContainer,
  LinkSpace
} from 'app/src/elements';
import Modal from '../../elements/Modal';
import NewTitleLog from './new';

const NavbarContainer = styled(View)`
  display: flex;
  flex-direction: row;
  flex: 0.25;
  align-items: center;
  height: 5px;
  background-color: ${elLightGray};
  padding: 15px;
  padding-left: 50px;
`;

const TableNavbarContainer = styled(View)`
  display: flex;
  flex-direction: row;
  flex: 0.25;
  align-items: center;
  height: 5px;
  background-color: ${elGray};
  padding: 15px;
  padding-left: 15px;
`;

const SubNav = ({refetch, tableNav, titleLog, asset}) => {
  const { assetId } = useParams();
  const [showAddTitleLogModal, setShowAddTitleLogModal] = useState(false);
  const location = useLocation();

  return (
    <TableNavbarContainer>
      {getLinks()}
    </TableNavbarContainer>
  )
  function getLinks() {
    return (
      <View>
        <Pressable
          onPress={() => setShowAddTitleLogModal(true)}
        >
          <Text>+ Add Title Log</Text>
        </Pressable>
        {showAddTitleLogModal &&
          <Modal
            showModal={showAddTitleLogModal}
            setShowModal={setShowAddTitleLogModal}
            modalType={'Add Title Log'}
          >
            <NewTitleLog
              setShowModal={setShowAddTitleLogModal}
              refetch={refetch}
              knownTitleLog={titleLog}
              assetId={assetId}
              knownAsset={asset}
            />
          </Modal>
        }
      </View>
    )
  }
}

export default SubNav;